import React from "react";
import { IoArrowUpCircleSharp } from "react-icons/io5";
import Lottie from "lottie-react";
import Loader from "../../../core/data/img/car_loading.json";

const Terms = ({ clearSignature, handleAccept, showScrollTop, handleScroll, scrollToTop, BookingAgreement, termsRef, isAccepted, signRef, loading }:
    {
        clearSignature: any, handleAccept: any, showScrollTop: any, handleScroll: any, scrollToTop: any, BookingAgreement: any,
        termsRef: any, isAccepted: any, signRef: any, loading: boolean,
    }) => {

    return (


        <>
            <div className="modal fade check-availability-modal" id="terms" role="dialog"  >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content py-0">

                        <div className="modal-body pt-0">
                            <div className="row">
                                <div className="col-2">
                                </div>
                                <div className="col-8 text-center">
                                </div>
                                <div className="col-2 d-flex justify-content-end">
                                    <span className="align-center text-black " data-bs-dismiss="modal"
                                        aria-label="Close" aria-hidden="true" style={{ fontSize: "xx-large" }}>
                                        ×
                                    </span>
                                </div>
                            </div>


                            {loading ?
                                <>
                                    <div className="d-flex justify-content-center">
                                        <Lottie
                                            animationData={Loader}
                                            loop={true}
                                            style={{ width: 100, height: 100 }}
                                        />
                                    </div>
                                </>
                                :
                                <div className="relative">
                                    <div
                                        ref={termsRef}
                                        onScroll={handleScroll}
                                        className="scroll-box border p-3"
                                        style={{
                                            height: `${isAccepted ? "calc(50vh + 2rem)" : "calc(80vh + 2rem)"}`,
                                            overflowY: 'auto',
                                        }}
                                    >
                                        <h6 className="text-center fw-bolder my-3">FAIRPY RENTAL CAR AGREEMENT</h6>
                                        <BookingAgreement />
                                    </div>

                                    <div className="float-end ">
                                        {showScrollTop &&
                                            <div onClick={scrollToTop} style={{
                                                marginTop: "-30px",
                                                marginRight: 0,
                                                zIndex: 99,
                                            }}>
                                                <IoArrowUpCircleSharp className="fs-1" color="text-primary" />
                                            </div>}
                                    </div>

                                    {isAccepted && (
                                        <>
                                            <div className="signature-area">
                                                <canvas ref={signRef} className="border p-3" />
                                            </div>

                                            <div className="text-center mt-3">
                                                <button
                                                    type="button"
                                                    className="btn bg-primary text-white me-1"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"
                                                    disabled={!isAccepted}
                                                    onClick={handleAccept}
                                                >
                                                    I Accept
                                                </button>

                                                <button
                                                    type="button"
                                                    className="btn btn-secondary me-1"
                                                    onClick={clearSignature}
                                                >
                                                    Clear
                                                </button>
                                            </div>
                                        </>
                                    )}
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default Terms;